export const APP = {
  NAV_WIDTH: '14.5rem',
  HEADER_HEIGHT: '50px',
  ACTION_BAR_HEIGHT_MOBILE: '10rem',
  ACTION_BAR_HEIGHT_DESKTOP: '5rem',
};

// See static/dashboard/precss/partials/_variables.css
export const DASHBOARD = {
  HEADER_HEIGHT: '3.75rem',
  HEADER_MOBILE_HEIGHT: '3.3125rem',
};
